import { Grid, Paper } from "@mui/material";
import React from "react";
import HeaderLogo from "../components/HeaderLogo/HeaderLogo";
import "../assets/css/RequestDiscountCode/RequestDiscountCode.css";
import DiscountCodeComponent from "../components/DiscountCodeComponent/DiscountCodeComponent";
import FooterSmall from "../components/Footer/FooterSmall";

const RequestDiscountCode: React.FC = () => {
  return (
    <>
      <div className="fullPageBackground">
        <HeaderLogo />
        <div className="root">
          <Paper className="loginContainer">
            <DiscountCodeComponent />
          </Paper>
        </div>
        <div style={{ width: "100vw" }}>
          <FooterSmall />
        </div>
      </div>
    </>
  );
};

export default RequestDiscountCode;
